<script>
import axios from 'axios';
export default {
  components: {},
  props: {
    objeto: {
      type: Object,
    },
  },
  data() {
    return {
      municipios:[]
    };
  },
  mounted(){
      axios.get('/municipios')
      .then((res) =>{
          const {response="",data=[]} = res.data;
          if (response === true) {
              this.municipios = data;
          }
      })
      .catch(err => {
          console.log(err);
      })
  }
}
</script>

<template>
<div>
  <div class="row mt-4">
    <div class="col-sm-12 col-md-4">
      <b><label class="form-check-label">Nombre</label> </b>
      <div class="mb-4">
        <b-form-input
          v-model="objeto.nombre"
          id="nombre"
          placeholder="Nombre"
        ></b-form-input>
      </div>
    </div>
    <div class="col-sm-12 col-md-4">
      <b><label class="form-check-label">Email</label> </b>
      <div class="mb-4">
        <b-form-input
          v-model="objeto.email"
          id="email"
          placeholder="Email"
        ></b-form-input>
      </div>
    </div>
    <div class="col-sm-12 col-md-4">
      <b><label class="form-check-label">Contraseña</label> </b>
      <div class="mb-4">
        <b-form-input
          v-model="objeto.password"
          id="password"
          placeholder="Contraseña"
        ></b-form-input>
      </div>
    </div>
  </div>
  <div class="row mt-4">
    <div class="col-sm-12 col-md-4">
        <b><label class="form-check-label">Municipio</label></b>
        <div class="mb-4">
            <b-form-select
                class="form-select"
                v-model="objeto.id_municipio"
                size="lg"
            >
                <option 
                    v-for="muni in municipios" 
                    :key="muni.nombre" 
                    :value="muni.id_municipio"
                    >{{muni.nombre}}
                </option>
            </b-form-select>
        </div>
    </div>
    </div>
    </div>
</template>
